import {planTypes} from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.ZOOM_DOCS],
  data () {
    return {
      logo: getPlanLogo(planTypes.ZOOM_DOCS),
      title: this.$t('billing.zoom_docs.title'),
      planType: planTypes.ZOOM_DOCS,
      description: this.$t('billing.zoom_docs.desc'),
    }
  }
};
